<style>
.tch-info-modal .ivu-modal-wrap {
  z-index: 2000;
}
</style>
<template>
  <div>
    <Modal :title="title" v-model="visible" width="600" v-drag-modal>
      <Form ref="tempLessonForm" class="form"
            :model="tempLessonParam" :rules="tempLessonRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item label="学生信息">
              <label>{{ tempLessonParam.uid }} - {{ tempLessonParam.mobile }} - {{ tempLessonParam.nickname }}</label>
            </Form-item>
          </Col>
          <Col :span="10">
            <Form-item>
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期"
                           @on-change="lsnBeginTimeDateChange" :clearable="false"
                           v-model="tempLessonParam.lsnBeginTimeDate"></Date-picker>
            </Form-item>
          </Col>
          <Col :span="10">
            <Form-item>
              <Time-picker @on-change="onChangeTime" :clearable="false" v-model="tempLessonParam.timeStr"
                           format="HH:mm" :steps="[1, 30]" placeholder="时间"></Time-picker>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="15">
             <Form-item label="">
               <RadioGroup v-model="tempLessonParam.accent">
                 <Radio label="1">
                   <span>英音</span>
                 </Radio>
                 <Radio label="2">
                   <span>美音</span>
                 </Radio>
               </RadioGroup>
               <RadioGroup v-model="tempLessonParam.sex">
                 <Radio label="1">
                   <span>男</span>
                 </Radio>
                 <Radio label="2">
                   <span>女</span>
                 </Radio>
               </RadioGroup>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="25">
              <Form-item label="">
                <RadioGroup v-model="tempLessonParam.canBound">
                  <Radio label="1">
                    <span>有绑定权限</span>
                  </Radio>
                  <Radio label="0">
                    <span>无绑定权限</span>
                  </Radio>
                </RadioGroup>
                <RadioGroup v-model="tempLessonParam.tchType">
                  <Radio label="1">
                    <span>外教课</span>
                  </Radio>
                  <Radio label="3">
                    <span>陪练课</span>
                  </Radio>
                </RadioGroup>
              </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="10">
            <Form-item label="">
              <Button type="info" @click="searchTch" :loading="loadingSearch">搜索</Button>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="28">
            <Form-item label="空课老师">
              <TeacherSelect :category="[1,2,3]" v-model="tId" :label="tchName"
                             @on-change="onTchChange"></TeacherSelect>
            </Form-item>
            <Form-item prop="tchId"  v-if="tchList.length > 0">
              <Row>
                <Radio-group v-model.number="tempLessonParam.tchId">
                  <Row>
                    <Col v-for="item in tchList" style="width: 160px;" :span="12" :key="item.id">
                      <Row>
                        <Radio :label="item.id">{{ item.id }} - {{ item.firstName }} {{ item.lastName }}</Radio>
                      </Row>
                      <div>
                        <a @click.stop="showTchMessage(item.id)">
                          <img :src="tchAvatarSrc(item.avatar)" style="width: 120px;height: 120px;">
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Radio-group>
              </Row>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button v-if="tempLessonParam.optType !== 3" type="text" size="large" @click="visible=false">取消</Button>
        <Button v-if="tempLessonParam.optType === 3" type="text" size="large" @click="visible=false">等会儿再看</Button>
        <Button type="primary" size="large" :loading="loadingConfirm" @click="insertTempLesson">
          {{ tempLessonParam.optType === 3 ? '修改代课信息' : '确认' }}
        </Button>
       <Button v-if="tempLessonParam.optType === 3" type="primary" size="large" :loading="loadingConfirm" @click="cancelProxy">直接取消</Button>
      </div>
    </Modal>
    <tch-info-modal class="tch-info-modal" :canEdit="false" :value="showTchInfoModal" @on-close="showTchInfoModal=false"
                    :tchId="tchId" :successCallback="updateTchInfoSuccess"></tch-info-modal>
  </div>
</template>
<script>
import TchInfoModal from '../../teacher/modal/TchInfoModal.vue'
import commonUtils from '@/tools/commonUtils.js'

export default {
  name: 'SearchChangeTchModal',
  components: {TchInfoModal},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
    changeTeacherOnly: {
      type: Boolean
    },
    optType: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    let self = this
    return {
      visible: this.value,
      loadingConfirm: false,
      onlyChangeTeacher: false,
      loadingSearch: false,
      classTypeList: [{code: 1, text: 'ClassIn'}],
      timeLengthList: [{code: 25, text: '25'}],
      bookMaterialLevelList: null,
      bookMaterialLessonsList: null,
      tchList: [],
      tchName: '',
      title: '',
      tId: '',
      tempLessonParam: {
        levelId: null,
        uid: null,
        category: '',
        makeUp: '',
        tchId: '',
        classType: 1,
        courseType: 1,
        lsnBeginTimeDate: null,
        lsnBeginTime: null,
        lsnBeginDayTime: null,
        timeLength: 25,
        suitableLevel: '',
        postpone: 0,
        time: null,
        sex: null,
        channel: null,
        schoolId: 0,
        tchType: '',
        optType: 0
      },
      timeStr: '',
      tempLessonRule: {
        levelId: [
          {type: 'integer', required: true, message: '请选择开始Level', trigger: 'blur'}
        ],
        lessonId: [
          {type: 'integer', required: true, message: '请选择开始课程', trigger: 'blur'}
        ],
        classType: [
          {type: 'integer', required: true, message: '请选择教室', trigger: 'change'}
        ],
        tchId: [
          {type: 'integer', required: true, message: '请搜索并选择老师', trigger: 'change'}
        ],
        lsnBeginDayTime: [
          {type: 'integer', required: true, message: '请选择日期', trigger: 'change'},
          {
            validator(rule, value, callback, source, options) {
              let errors = []
              if (self.tempLessonParam.time === '') {
                errors.push('请选择时间')
                callback(errors)
                return
              }
              let lsnBeginTime = self.getLsnBeginTime()
              let nowTime = new Date().getTime() / 1000
              if (lsnBeginTime !== '' && nowTime >= lsnBeginTime) {
                errors.push('开始时间应在当前时间之后')
                callback(errors)
                return
              }
              callback()
            }
          }
        ]
      },
      tchId: null,
      showTchInfoModal: false,
      ptype: ''
    }
  },
  methods: {
    tchAvatarSrc (avatar) {
      return commonUtils.getTotalUrl(avatar) || 'https://medias.kouyujie.cn/2018-02-09-defaultImageWechatIMG223.jpeg'
    },
    insertTempLesson() {
      let self = this
      self.loadingConfirm = true
      self.$http.post('/bookLesson/opened/changeTch', {
        lsnBeginTime: self.getLsnBeginTime(),
        timeLength: self.tempLessonParam.timeLength,
        openedId: self.tempLessonParam.openedId,
        tchId: self.tempLessonParam.tchId,
        changeTeacherOnly: self.onlyChangeTeacher
      }).then(function (res) {
        self.loadingConfirm = false
        if (res) {
          self.$Message.success('约课成功!')
          self.successCallback()
          self.visible = false
        }
      })
    },
    searchTch () {
      let self = this
      self.loadingSearch = true
      self.tchList = []
      let path = '/tch/time/queryFreeNotChineseTch?lsnBeginTime=' + self.getLsnBeginTime() +
        '&timeLength=' + self.tempLessonParam.timeLength + '&tempSchedule=1&uid=' + self.tempLessonParam.uid
      path = path + '&tchType=' + self.tempLessonParam.tchType
      if (self.ptype === '1') {
        path = path + '&isAudition=y'
      }
      if (self.tempLessonParam.canBound) {
        path = path + '&canBound=' + self.tempLessonParam.canBound
      }
      if (self.tempLessonParam.category) {
        path = path + '&category=' + self.tempLessonParam.category
      }
      if (self.tId) {
        path = path + '&tchId=' + self.tId
      }
      if (self.tempLessonParam.accent) {
        path = path + '&accent=' + self.tempLessonParam.accent
      }
      if (self.tempLessonParam.sex) {
        path = path + '&sex=' + self.tempLessonParam.sex
      }
      if (self.tempLessonParam.channel) {
        path = path + '&channel=' + self.tempLessonParam.channel
      }

      self.$http.post(path).then(function (res) {
        if (res && res.data) {
          self.tchList = res.data
        }
        self.loadingSearch = false
      })
    },
    getLsnBeginTime () {
      return parseInt(this.tempLessonParam.lsnBeginDayTime) + parseInt(this.tempLessonParam.time)
    },
    clearTchList () {
      this.tchList = []
      this.tempLessonParam.tchId = ''
    },
    showTchMessage (id) {
      this.tchId = parseInt(id)
      this.showTchInfoModal = true
    },
    updateTchInfoSuccess () {
      this.showTchInfoModal = false
    },
    onTchChange (id, name) {
      this.tchName = name
      if (id) {
        this.searchTch()
      }
    },
    lsnBeginTimeDateChange (value) {
      this.tempLessonParam.lsnBeginDayTime = value && parseInt(this.$moment(value, 'YYYY-M-D').format('X'))
      this.clearTchList()
    },
    onChangeTime (val) {
      this.tempLessonParam.time = val && parseInt(this.$dateUtil.getSecondByHm(val))
      this.clearTchList()
    },
    cancelProxy () {
      let self = this
      self.loadingConfirm = true
      self.$http.post('/bookLesson/cancelProxy', {id: this.tempLessonParam.openedId}).then(function (res) {
        self.loadingConfirm = false
        if (res.status === 'ok') {
          self.successCallback()
          self.visible = false
        } else {
          self.$Message.error(res.msg)
        }
      })
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible (val) {
      let $moment = this.$moment
      if (val === true) {
        this.tchList = []
        this.loadingConfirm = false
        this.loadingSearch = false
        this.bookMaterialLevelList = null
        this.bookMaterialLessonsList = null
        this.tempLessonParam.uid = this.user.uid
        this.tempLessonParam.nickname = this.user.userNickname
        this.tempLessonParam.mobile = this.user.mobile
        this.tempLessonParam.lsnBeginTimeDate = this.user.lsnBeginTime * 1000
        this.tempLessonParam.lsnBeginDayTime = Math.floor(new Date(this.user.lsnBeginTime * 1000).setHours(0, 0, 0, 0) / 1000)
        this.tempLessonParam.timeLength = this.user.courseTime
        this.tempLessonParam.timeStr = $moment(this.user.lsnBeginTime, 'X').format('HH:mm')
        this.tempLessonParam.time = parseInt(this.$dateUtil.getSecondByHm(this.tempLessonParam.timeStr))
        this.tempLessonParam.channel = this.user.tchChannel
        this.tempLessonParam.openedId = this.user.id
        this.tempLessonParam.tchType = ''
        this.tempLessonParam.optType = this.optType
        this.onlyChangeTeacher = this.changeTeacherOnly
        this.title = this.optType === 2 ? '更换老师/时间' : this.optType === 1 ? '老师代课' : '取消代课'
      } else {
        this.tId = ''
        this.tchName = ''
        this.tempLessonParam = {}
        this.clearTchList()
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchChangeTchModal.vue?70874fba